var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-box",on:{"click":_vm.onBoxClick}},[_c('van-icon',{staticClass:"icon-tip",attrs:{"size":"27","name":"photo-o"}}),_c('span',[_vm._v(_vm._s(_vm.desc))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }